import HourglassIcon from '@jetbrains/icons/hourglass.svg'
import classNames from 'classnames'
import * as React from 'react'

import {useDistanceToNow} from '../../../../../hooks/useTimeSelector'
import {stringifyId} from '../../../../../types'
import AgentLink from '../../../../common/AgentLink/AgentLink.container'
import Icon from '../../../../common/Icon/Icon'
import Link from '../../../../common/Link/Link'
import MiddleEllipsis from '../../../../common/MiddleEllipsis/MiddleEllipsis'
import SvgIcon from '../../../../common/SvgIcon/SvgIcon'
import {getStatus} from '../../../../pages/AgentsPages/components/EnableAgentForm/EnableAgentForm.utils'

import type {Props} from './AgentStatus.types'

import styles from './AgentStatus.css'

function AgentStatus(props: Props) {
  const {
    className,
    agentId,
    isEnabled,
    isAuthorized,
    withPool,
    statusSwitchTime,
    poolId,
    poolName,
    uptodate,
    hasBuild,
    authorizedComment,
  } = props
  const classes = classNames(styles.agentStatus, className)
  const commentLineClasses = classNames(styles.line, {
    [styles.idleCommentLine]: !hasBuild,
  })
  const outdatedMessage = isAuthorized && uptodate === false ? 'The agent is outdated' : null
  const unAuthorizedMessage = !isAuthorized ? authorizedComment : null
  const statusSwitchFromNow = useDistanceToNow(statusSwitchTime)
  const timerMessage =
    isAuthorized && statusSwitchFromNow != null
      ? `Will be automatically ${getStatus(!isEnabled)} ${statusSwitchFromNow}.`
      : null
  return (
    <div className={classes}>
      <div className={styles.line}>
        <AgentLink className={styles.link} agentId={agentId} />
        {withPool === true && poolId != null && poolName != null && (
          <Link
            href={`/agents.html?tab=agentPools#${stringifyId(poolId)}`}
            className={styles.pool}
            key="link"
            relative
          >
            <MiddleEllipsis title={`${poolName} pool`}>{poolName}</MiddleEllipsis>
          </Link>
        )}
      </div>
      {outdatedMessage && (
        <div className={commentLineClasses}>
          <span className={styles.icon}>
            <Icon name="warning" />
          </span>
          <MiddleEllipsis className={styles.comment}>{outdatedMessage}</MiddleEllipsis>
        </div>
      )}
      {timerMessage != null && (
        <div className={commentLineClasses}>
          <span className={styles.icon}>
            <SvgIcon icon={HourglassIcon} />
          </span>
          <MiddleEllipsis className={styles.comment}>{timerMessage}</MiddleEllipsis>
        </div>
      )}
      {unAuthorizedMessage != null && (
        <div className={commentLineClasses}>
          <span className={styles.icon} />
          <MiddleEllipsis className={styles.comment}>{unAuthorizedMessage}</MiddleEllipsis>
        </div>
      )}
    </div>
  )
}

export default AgentStatus
